import { Component, input, InputSignal, ChangeDetectionStrategy } from '@angular/core';
import { ProductPriceFormatterComponent } from '../product-price-formatter';

@Component({
  selector: 'ui-product-price-reimbursement',
  imports: [
    ProductPriceFormatterComponent,
  ],
  templateUrl: './product-price-reimbursement.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './product-price-reimbursement.component.scss',
})
export class ProductPriceReimbursementComponent {
  public small: InputSignal<boolean> = input(false);
  public price: InputSignal<number> = input.required();
  public showThousandthsPlace: InputSignal<boolean> = input(false);
}
